import React, { useState, useEffect } from "react";
import "../../members/screens/MemberPrint.css";
import { PhotoTable } from "../../../components/ui/TablePrintFormat";
import { BASE_URL } from "../../../env";
import { calculateEmiAmountRaw } from "../../../utils/utils";

const GeneratedEmiSchedule = ({ memberDetails }) => {
  const [generatedSchedule, setGeneratedSchedule] = useState([]);
  const [totalInterest, setTotalInterest] = useState(0);

  useEffect(() => {
    handleGenerateSchedule(); // Call the function to generate the schedule
  }, []);

  // const handleGenerateSchedule = () => {
  //   const expectedLoanAmount =
  //     memberDetails.memberDetails.loanType === "Business Loan"
  //       ? memberDetails.memberDetails.sanctionedLoanAmountBySanctionCommittee
  //       : memberDetails.memberDetails.loanType === "GP Loan"
  //       ? memberDetails.memberDetails.eligibleLoanAmountByBm
  //       : "";
  //   const rateOfInterest = memberDetails.proposedLoanDetails.rateOfInterest;
  //   const tenureInMonths = memberDetails.proposedLoanDetails.tenureInMonths;
  //   const emiDateValue = memberDetails.memberDetails.emiDateByBranchManager
  //     ? memberDetails.memberDetails.emiDateByBranchManager
  //     : memberDetails.proposedLoanDetails.emiDate;

  //   const monthlyRate = rateOfInterest / 12 / 100;
  //   const emi =
  //     (expectedLoanAmount *
  //       monthlyRate *
  //       Math.pow(1 + monthlyRate, tenureInMonths)) /
  //     (Math.pow(1 + monthlyRate, tenureInMonths) - 1);

  //   let balance = expectedLoanAmount;
  //   let beginingBalance = balance;
  //   let sumOfInterest = 0;
  //   const schedule = [];


  //   let transactionDate = new Date(
  //     memberDetails.memberDetails.branchManagerStatusUpdatedAt
  //   );

  //   for (let month = 1; month <= tenureInMonths; month++) {
  //     const interest = balance * monthlyRate;
  //     const principal = emi - interest;
  //     beginingBalance = balance;
  //     balance -= principal;
  //     sumOfInterest += interest;

  //     // Calculate the EMI date for the current month
  //     const paymentDate = new Date(transactionDate);
  //     paymentDate.setMonth(transactionDate.getMonth() + month); // Add the current month to the transaction date
  //     const daysInMonth = new Date(
  //       paymentDate.getFullYear(),
  //       paymentDate.getMonth() + 1,
  //       0
  //     ).getDate(); 



  //     if (emiDateValue > daysInMonth) {
  //       paymentDate.setDate(daysInMonth);
  //     } else {
  //       paymentDate.setDate(emiDateValue); 
  //     }

  //     schedule.push({
  //       month,
  //       emi,
  //       principal,
  //       interest,
  //       balance: balance > 0 ? balance : 0,
  //       emiDate: `${String(paymentDate.getDate()).padStart(2, "0")}-${String(
  //         paymentDate.getMonth() + 1
  //       ).padStart(2, "0")}-${paymentDate.getFullYear()}`, // Format as DD-MM-YYYY
  //       beginingBalance,
  //     });
  //   }
  //   setGeneratedSchedule(schedule);
  //   setTotalInterest(sumOfInterest);
  // };

  const handleGenerateSchedule = () => {
    const expectedLoanAmount =
      memberDetails.memberDetails.loanType === "Business Loan"
        ? memberDetails.memberDetails.sanctionedLoanAmountBySanctionCommittee || memberDetails.proposedLoanDetails.loanAmount
        : memberDetails.memberDetails.loanType === "GP Loan"
          ? memberDetails.memberDetails.eligibleLoanAmountByBm || memberDetails.proposedLoanDetails.loanAmount
          : memberDetails.proposedLoanDetails.loanAmount || 0;
    const rateOfInterest = parseFloat(memberDetails.proposedLoanDetails.rateOfInterest) || 0;
    const tenureInMonths = parseInt(memberDetails.proposedLoanDetails.tenureInMonths) || 0;
    const emiDateValue = memberDetails.memberDetails.emiDateByBranchManager
      ? memberDetails.memberDetails.emiDateByBranchManager
      : memberDetails.proposedLoanDetails.emiDate
    const monthlyRate = rateOfInterest / 12 / 100;

    // Always recalculate EMI from the actual approved loan amount.
    // Do NOT use proposedLoanDetails.monthlyEmi — that was entered by CRO
    // based on the originally proposed amount (e.g. 90,000), not the actual
    // approved gold loan amount (e.g. 67,280). Using the stale value causes
    // the loan to pay off early and produces negative values in later months.
    let emi = 0;
    if (monthlyRate > 0 && tenureInMonths > 0) {
      emi = calculateEmiAmountRaw(expectedLoanAmount, rateOfInterest, tenureInMonths);
    } else if (tenureInMonths > 0) {
      emi = expectedLoanAmount / tenureInMonths;
    }

    const roundedEmi = Math.round(emi);
    let currentBalance = Math.round(expectedLoanAmount);
    let sumOfInterest = 0;
    const schedule = [];

    let transactionDate = new Date(
      memberDetails.memberDetails.branchManagerStatusUpdatedAt || new Date()
    );
    if (isNaN(transactionDate.getTime())) transactionDate = new Date();

    for (let month = 1; month <= tenureInMonths; month++) {
      // Safety guard: if balance is already 0 or negative (due to rounding
      // drift in earlier months), stop — never generate negative-balance rows.
      if (currentBalance <= 0) break;

      let interest = Math.round(currentBalance * monthlyRate);
      let principal;
      let actualEmi;

      if (month === tenureInMonths) {
        // Last month: pay off exactly whatever balance remains.
        // Recalculate interest on the real remaining balance (not a derived value)
        // so the final row is always mathematically correct.
        interest = Math.round(currentBalance * monthlyRate);
        principal = currentBalance;
        actualEmi = principal + interest; // Final EMI settles the loan exactly
      } else {
        principal = roundedEmi - interest;
        actualEmi = roundedEmi;
      }

      const beginningBalance = currentBalance;
      currentBalance -= principal;

      // Clamp: floating-point / rounding across many months can drift the
      // balance slightly below 0. Pin to 0 so it never appears negative in
      // the printed document.
      if (currentBalance < 0) currentBalance = 0;
      sumOfInterest += interest;

      let paymentDate;
      let emiDay = 1;
      
      const selectedFullDate = new Date(emiDateValue);
      if (!isNaN(selectedFullDate.getTime()) && typeof emiDateValue === 'string' && emiDateValue.includes('-')) {
        emiDay = selectedFullDate.getDate();
        paymentDate = new Date(selectedFullDate.getFullYear(), selectedFullDate.getMonth() + (month - 1), 1);
      } else {
        emiDay = parseInt(emiDateValue) || 1;
        paymentDate = new Date(transactionDate.getFullYear(), transactionDate.getMonth() + month, 1);
      }
      
      const daysInTargetMonth = new Date(paymentDate.getFullYear(), paymentDate.getMonth() + 1, 0).getDate();
      paymentDate.setDate(Math.min(emiDay, daysInTargetMonth));

      schedule.push({
        month,
        emi: actualEmi,
        principal,
        interest,
        balance: currentBalance,
        emiDate: `${String(paymentDate.getDate()).padStart(2, "0")}/${String(
          paymentDate.getMonth() + 1
        ).padStart(2, "0")}/${paymentDate.getFullYear()}`,
        beginningBalance,
      });
    }
    setGeneratedSchedule(schedule);
    setTotalInterest(sumOfInterest);
  };


  return (
    <div>
      <div>
        <h1 className="section text-center">Repayment Schedule</h1>
        <div>
          <table
            className="table table-striped text-center table-bordered"
            style={{
              width: "100%",
              fontSize: "26px",
              borderCollapse: "collapse",
              border: "1.5px solid black",
            }}
          >
            <tbody>
              <tr className="section">
                <td
                  style={{
                    width: "30%",
                    border: "1.5px solid black",
                    padding: "2px",
                  }}
                >
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ width: "50%" }}>
                        <b>Customer Name</b>
                      </div>
                      <div style={{ width: "50%" }}>
                        {memberDetails.memberDetails.memberName}
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: "10px",
                      }}
                    >
                      <div style={{ width: "50%" }}>
                        <b>Branch Name</b>
                      </div>
                      <div style={{ width: "50%" }}>
                        {memberDetails.branchName}
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: "10px",
                      }}
                    >
                      <div style={{ width: "50%" }}>
                        <b>Rate of Interest</b>
                      </div>
                      <div style={{ width: "50%" }}>
                        {memberDetails.proposedLoanDetails.rateOfInterest}%
                      </div>
                    </div>
                  </div>
                </td>
                <td style={{ width: "20%", border: "1.5px solid black" }}>
                  <img
                    src={`${BASE_URL}/images/${memberDetails.memberDocuments.memberPhoto}`}
                    alt=""
                    style={{ width: "150px", height: "150px" }}
                  />
                </td>
                <td style={{ width: "20%", border: "1.5px solid black" }}>
                  <img
                    src={`${BASE_URL}/images/${memberDetails.nomineeDocuments.nomineePhoto}`}
                    alt=""
                    style={{ width: "150px", height: "150px" }}
                  />
                </td>
                <td
                  style={{
                    width: "30%",
                    border: "1.5px solid black",
                    padding: "2px",
                  }}
                >
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ width: "50%" }}>
                        <b>Customer ID</b>
                      </div>
                      <div style={{ width: "50%" }}>
                        {memberDetails.memberDetails.customerId}
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: "10px",
                      }}
                    >
                      <div style={{ width: "50%" }}>
                        <b>Loan Amount</b>
                      </div>
                      <div style={{ width: "50%" }}>
                        {memberDetails.memberDetails.loanType ===
                          "Business Loan"
                          ? memberDetails.memberDetails
                            .sanctionedLoanAmountBySanctionCommittee ??
                          memberDetails.proposedLoanDetails.loanAmount
                          : memberDetails.memberDetails.loanType === "GP Loan"
                            ? memberDetails.memberDetails.eligibleLoanAmountByBm ??
                            memberDetails.proposedLoanDetails.loanAmount
                            : memberDetails.proposedLoanDetails.loanAmount}
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: "10px",
                      }}
                    >
                      <div style={{ width: "50%" }}>
                        <b>Tenure</b>
                      </div>
                      <div style={{ width: "50%" }}>
                        {memberDetails.proposedLoanDetails.tenureInMonths}{" "}
                        months
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <div className="table-responsive">
            <table
              className="table table-striped text-center table-bordered"
              style={{
                fontSize: "26px",
                borderCollapse: "collapse",
                border: "1.5px solid black",
              }}
            >
              <thead className="primaryColor thead_sticky bg-primary">
                <tr className="section">
                  <th style={{ border: "1.5px solid black", padding: "0" }}>
                    S.No
                  </th>
                  <th style={{ border: "1.5px solid black", padding: "0" }}>
                    Repayment Date
                  </th>
                  <th style={{ border: "1.5px solid black", padding: "0" }}>
                    Principal
                  </th>
                  <th style={{ border: "1.5px solid black", padding: "0" }}>
                    Interest
                  </th>
                  <th style={{ border: "1.5px solid black", padding: "0" }}>
                    Total EMI
                  </th>
                  <th style={{ border: "1.5px solid black", padding: "0" }}>
                    Outstanding Balance
                  </th>
                </tr>
              </thead>
              <tbody>
                {generatedSchedule.map((item, index) => (
                  <tr key={index} className="section">
                    <td style={{ border: "1.5px solid black", padding: "0" }}>
                      {index + 1}
                    </td>
                    <td style={{ border: "1.5px solid black", padding: "0" }}>
                      {item.emiDate}
                    </td>
                    <td style={{ border: "1.5px solid black", padding: "0" }}>
                      {item.principal}
                    </td>
                    <td style={{ border: "1.5px solid black", padding: "0" }}>
                      {item.interest}
                    </td>
                    <td style={{ border: "1.5px solid black", padding: "0" }}>
                      {item.emi}
                    </td>
                    <td style={{ border: "1.5px solid black", padding: "0" }}>
                      {item.balance}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GeneratedEmiSchedule;
